import { usePostHog } from "posthog-js/react";
import { useGlobalContext } from "context/GlobalContext";
import { DateRangePicker } from "components/DateRangePicker/DateRangePicker";

export const OrdersDatePicker = () => {
  const { dates, setDates } = useGlobalContext();
  const posthog = usePostHog();

  const handleDateRangeChange = (dateRange) => {
    setDates(dateRange);
    posthog.capture("date-range-changed", dateRange);
  };

  return (
    <DateRangePicker
      dates={dates}
      onChange={handleDateRangeChange}
    />
  );
};
